import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/accreditations.png.js';
import css_248z from './footer.scss.js';
import img$1 from '../../../../assets/images/arrow-up-icon.svg.js';

class Footer extends s {
    constructor() {
        super();
        this.goUpText = 'Go up';
        this.goToHomePageText = 'Go to Homepage';
        this._query = '(max-width: 1365px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    firstUpdated() {
        if (this.renderRoot
            .querySelector('slot[name="sitemap-group"]')
            .assignedElements().length < 1)
            this.renderRoot.querySelector('.sitemap').style.display =
                'none';
        if (this.renderRoot
            .querySelector('slot[name="social-link"]')
            .assignedElements().length < 1) {
            this.renderRoot
                .querySelector('.row.social')
                .classList.add('empty');
        }
    }
    render() {
        return x `<lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query><div class="footer ${o({
            rtl: this.rtl || isRTL(),
        })}"><div class="top"><div class="row social"><slot name="social-link"></slot></div><div class="row logo"><img loading="lazy" src="${img}" alt="" aria-hidden="true"></div><div class="row go-up"><a href="#top" class="icon-button style-dark" aria-label="Back to top" styleType="dark" ariaLabel="${this.goUpText}"><img slot="icon" src="${img$1}" alt="Arrow pointing up" aria-hidden="true"></a></div></div><div class="sitemap"><slot name="sitemap-group"></slot></div><div class="sitemap-mobile"><slot name="sitemap-mobile-item"></slot></div><slot name="legal"></slot><slot name="bottom"></slot></div>`;
    }
}
Footer.styles = css_248z;
__decorate([
    n({ type: String })
], Footer.prototype, "homepageUrl", void 0);
__decorate([
    n()
], Footer.prototype, "goUpText", void 0);
__decorate([
    n()
], Footer.prototype, "goToHomePageText", void 0);
__decorate([
    n({ type: Boolean })
], Footer.prototype, "rtl", void 0);
customElements.define('cvt-footer', Footer);

export { Footer };
